export const formatCategoryName = (category: string | null | undefined): string => {
  if (!category) return "";

  return category
    .replace(/_/g, " ")        // replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize each word
};

export const normalizeSeriesType = (type: string | null | undefined): string => {
  if (!type) return "";

  return type?.toLowerCase().replace(/-/g, "_");
};